<template>
  <div v-if="visible" class="mr-4" :title="title">
    <v-icon small class="mr-1" style="margin-top: -5px"> {{ icon }} </v-icon>
    <span v-html="text"></span>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    title: String,
    icon: String,
    text: String,
    always: Boolean,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {
    visible() {
      return (
        this.text && (this.text.includes("class='highlight'") || this.always)
      );
    },
  },
};
</script>
